"use client";

import { AssistProvider } from "@/components/Assist/AssistContext";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthContextProvider } from "@/context/auth-context";
import { DebugSettingsProvider } from "@/hooks/use-debug-settings";
import { TrackerProvider } from "@/hooks/use-tracker";
import { UserLocalSettingsProvider } from "@/hooks/use-user-local-settings";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { ActiveDocumentProvider } from "./active-document";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());
  return (
    <DebugSettingsProvider>
      <UserLocalSettingsProvider>
        <QueryClientProvider client={queryClient}>
          <AuthContextProvider>
            <TrackerProvider>
              <TooltipProvider>
                <AssistProvider>
                  <ActiveDocumentProvider>{children}</ActiveDocumentProvider>
                </AssistProvider>
              </TooltipProvider>
            </TrackerProvider>
          </AuthContextProvider>
        </QueryClientProvider>
      </UserLocalSettingsProvider>
    </DebugSettingsProvider>
  );
}
